import { Navigate, useLocation } from "react-router-dom";
import { Show } from "@clerk/react";

export const RequireAuth = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <>
      <Show when="signed-in">{children}</Show>
      <Show when="signed-out"><Navigate to={`/sign-in?redirect_url=${encodeURIComponent(pathname)}`} replace /></Show>
    </>
  );
};

export const PageHead = ({ eyebrow, title, children }) => (
  <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-14 md:px-10 md:pt-20">
    <p className="eyebrow rise text-terracotta">{eyebrow}</p>
    <h1 className="rise rise-1 mt-3 max-w-3xl text-4xl tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
    {children && <div className="rise rise-2 mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">{children}</div>}
  </div>
);
